<template>
  <div>
    <!--  Item with a group of objects -->
    <div v-if="Array.isArray(itemData)">
      <div class="collection-item"
           :class="'is-' + itemData.length"
           :style="'background-image: url(' + imagePath(itemData[0]) + ')'" >
      </div>

      <h4 class="title is-5" v-html="markdown(title)"></h4>
      <h5 class="subtitle is-6">Group: {{ itemData.length }} items</h5>
    </div>

    <!--  Item with a single object -->
    <div v-else>
      <div class="collection-item is-1"
           :style="'background-image: url(' + imagePath(itemData) + ')'">
      </div>

      <h4 class="title is-5" v-html="markdown(title)"></h4>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { markdown } from '@/utils.js'
export default {
  name: 'archiveCollectionItem',
  props: ['title', 'itemData', 'caption'],

  computed: {
    ...mapGetters(['chapter'])
  },

  methods: {
    imagePath (item) {
      if (item.filename) {
        if (Array.isArray(item.filename)) {
          return require(`@/assets/images/${this.chapter.shortname}/archive/${item.filename[0]}`)
        } else {
          return require(`@/assets/images/${this.chapter.shortname}/archive/${item.filename}`)
        }
      } else {
        return false
      }
    },

    markdown: markdown
  }
}
</script>

<style lang="scss">
@import "../assets/styles/main.scss";
$collection-item-height: 200px;

.collection-item {
  background-position: center center;
  background-size: cover;
  border: solid 1px #fff;
  height: $collection-item-height;
  margin-bottom: 1rem;
  width: 100%;

  @for $i from 1 through 20 {
    &.is-#{$i} {
      box-shadow: stack-shadow($i);
    }
  }

  ~ .title {
    background-color: $black;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/ArchiveCollectionItem.vue?17352a62